/*! Lazy Image - FloraVines performance optimized */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    if (!this.hasAttribute('loading')) this.loading = 'lazy';
    if (!this.hasAttribute('decoding')) this.decoding = 'async';

    this.wrapper = this.closest('.media-wrapper');
    if (!this.wrapper || this.complete) {
      this.classList.add('loaded');
      return;
    }

    this.wrapper.classList.add('loading');
    this.addEventListener('load', () => {
      const finish = () => {
        this.classList.add('loaded');
        this.wrapper && this.wrapper.classList.remove('loading');
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(finish, { timeout: 150 });
      } else {
        setTimeout(finish, 0);
      }
    }, { once: true });
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, {
      signal: this.abortController.signal,
      passive: true
    });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      const hqImage = this.getAttribute('data-hq');
      const source = this.querySelector('source');
      if (hqImage && source) source.setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });
